import {ReactNode} from 'react';
import {OnboardingStep, PrescoreValidationResult, StepStatus} from "../../../../api-client";

export enum WizardStep {
  START = 1,
  VERIFICATION = 2,
  SCORING = 3,
  DOCUMENTS = 4,
}

export const onboardingStepToWizardStep = (step: OnboardingStep): WizardStep => {
  const map: Record<OnboardingStep, WizardStep> = {
    [OnboardingStep.PRESCORING]: WizardStep.START,
    [OnboardingStep.IDENTIFICATION]: WizardStep.VERIFICATION,
    [OnboardingStep.SCORING]: WizardStep.SCORING,
    [OnboardingStep.LEGAL]: WizardStep.DOCUMENTS,
    [OnboardingStep.PROJECT_CREATION]: WizardStep.DOCUMENTS,
  };
  return map[step] ?? WizardStep.START;
};

export interface StepConfig {
  id: WizardStep;
  label: string;
  sublabel?: string;
  icon?: ReactNode;
  isCompleted?: boolean;
  isDisabled?: boolean;
}

export interface WizardContextValue {
  activeStep: WizardStep;
  setActiveStep: (step: WizardStep) => void;
  goToNextStep: () => void;
  goToPreviousStep: () => void;
  isStepCompleted: (step: WizardStep) => boolean;
  completedSteps: WizardStep[];
  markStepCompleted: (step: WizardStep) => void;
  onboardingStepStatus: StepStatus | null;
  setOnboardingStepStatus: (status: StepStatus | null) => void;
  backendCurrentStep: WizardStep | null;
  setBackendCurrentStep: (step: WizardStep | null) => void;
  onboardingStepNote: string | undefined;
  setOnboardingStepNote: (note: string | undefined) => void;
  prescoreDraft: PrescoreDraft;
  setPrescoreDraft: (draft: PrescoreDraft) => void;
  lastPrescoreResult: PrescoreValidationResult | null;
  setLastPrescoreResult: (result: PrescoreValidationResult | null) => void;
  isInitialDataLoaded: boolean;
  setIsInitialDataLoaded: (loaded: boolean) => void;
  refreshOnboardingState: (options?: RefreshOnboardingOptions) => Promise<void>;
  setRefreshCallback: (callback: (options?: RefreshOnboardingOptions) => Promise<void>) => void;
}

export interface RefreshOnboardingOptions {
  silent?: boolean;
  /** Не переключать активный шаг (оставить текущий экран после обновления состояния с бэкенда) */
  keepCurrentStep?: boolean;
}

export interface PrescoreDraft {
  borrowerInn: string;
  debitorInns: string[];
}

export interface FAQItem {
  id: string;
  question: string;
  answer: string | ReactNode;
}

